module.exports = __webpack_public_path__ + "img/Diversity.546260c9.svg";